import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as customTabActions from "../../../../actions/customTabActions";
import * as navigationActions from "../../../../actions/navigationActions";
import * as modelHelper from "../../../../helpers/modelHelper";

import Button, {BUTTON_SMALL} from "../../../global/generic/Button";
import CancelButton from "../../../global/generic/CancelButton";
import imgEdit from "../../../../resources/img/svgicons/edit.svg";
import imgAdd from "../../../../resources/img/svgicons/add-colorant.svg";
import imgDelete from "../../../../resources/img/svgicons/delete.svg";
import imgConfirm from "../../../../resources/img/svgicons/confirm.svg";
import Modal from "../../../global/generic/Modal";
import Table from "../../../global/generic/Table";
import SearchInput from "../../../global/generic/SearchInput";
import {INPUT_MEDIUM} from "../../../global/generic/Input";

class CustomFandecksModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchInput: "",
            customObject: null
        };
    }

    componentDidUpdate = () => {
        if (this.state.customObject !== null) {
            if (this.filterFandeckList().filter((record) => record.id === this.state.customObject.id).length === 0) {
                this.setState({customObject: null});
            }
        }
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseCustomFandecksModalAction();
    };

    handleCustomFandecksSearchInputChange = (event) => {
        this.setState({searchInput: event.target.value});
    };

    getRowClassName = (fandeckId) => {
        let className = "cursor-pointer";
        if (this.state.customObject?.id === fandeckId) {
            return className + " active";
        }

        return className;
    };

    getTableHeader = () => {
        return modelHelper.buildTableRow([modelHelper.buildTableCell(<Translate value="general.fandeckName" />)]);
    };

    getTableColumns = () => {
        return [modelHelper.buildTableColumn("col-12")];
    };

    getTableRows = () => {
        return this.filterFandeckList().map((record) => {
            return modelHelper.buildTableRow(
                [modelHelper.buildTableCell(record.name, "", "", {"data-uuid": record.id})],
                this.getRowClassName(record.id),
                record.id,
                {
                    "data-uuid": record.id,
                    onClick: this.handleCustomFandeckItemClick
                }
            );
        });
    };

    filterFandeckList = () => {
        return this.props.customFandeckList.filter(
            (record) =>
                this.state.searchInput === "" ||
                record.name.toLowerCase().includes(this.state.searchInput.toLowerCase())
        );
    };

    findFandeck = (id) => {
        for (let fandeck of this.props.customFandeckList) {
            if (Number(fandeck.id) === Number(id)) {
                return fandeck;
            }
        }
        return null;
    };

    handleCustomFandeckItemClick = (event) => {
        let fandeck = this.findFandeck(event.target.dataset.uuid);

        this.setState({
            customObject: fandeck !== null ? fandeck : null
        });
    };

    handleAddCustomFandeckClick = () => {
        this.props.dispatchOpenAddCustomFandeckModalAction(this.props.tabId);
    };

    handleEditCustomFandeckClick = () => {
        if (this.state.customObject !== null) {
            this.props.dispatchOpenEditCustomFandeckModalAction(this.props.tabId, this.state.customObject);
        }
    };

    handleRemoveCustomFandeckClick = () => {
        if (this.state.customObject !== null) {
            this.props.dispatchRemoveCustomFandeckAction(this.state.customObject);
            this.setState({customObject: null});
        }
    };

    handleSelectCustomFandeckClick = () => {
        if (this.state.customObject !== null) {
            this.props.dispatchSelectCustomFandeckAction(this.props.tabId, this.state.customObject);
        }
    };

    handleClearInputClick = () => {
        this.setState({
            searchInput: ""
        });
    };

    getOkButton = () => {
        if (this.state.customObject !== null) {
            return (
                <Button
                    className={"margin-right-5"}
                    onClick={this.handleSelectCustomFandeckClick}
                    svgBefore={imgConfirm}
                    label={<Translate value="general.confirm" />}
                />
            );
        }

        return (
            <Button
                className={"margin-right-5"}
                onClick={this.handleSelectCustomFandeckClick}
                svgBefore={imgConfirm}
                label={<Translate value="general.confirm" />}
                disabled={true}
            />
        );
    };

    getActionButtons = () => {
        return (
            <React.Fragment>
                <Button
                    size={BUTTON_SMALL}
                    onClick={this.handleAddCustomFandeckClick}
                    label={<Translate value="general.add" />}
                    svgBefore={imgAdd}
                />
                <Button
                    size={BUTTON_SMALL}
                    onClick={this.handleEditCustomFandeckClick}
                    label={<Translate value="general.edit" />}
                    svgBefore={imgEdit}
                    disabled={this.state.customObject === null}
                />
                <Button
                    size={BUTTON_SMALL}
                    onClick={this.handleRemoveCustomFandeckClick}
                    label={<Translate value="general.delete" />}
                    svgBefore={imgDelete}
                    disabled={this.state.customObject === null}
                    tooltipText={
                        this.state.customObject !== null ? translate("customFandecks.deleteButtonWarning") : undefined
                    }
                />
            </React.Fragment>
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 flex-wrap flex flex-align-center-vertical flex-gap-10px">
                    {this.getActionButtons()}
                    <SearchInput
                        className="primary-input margin-left-auto col-4"
                        size={INPUT_MEDIUM}
                        resetFilterClick={this.handleClearInputClick}
                        onChange={this.handleCustomFandecksSearchInputChange}
                        value={this.state.searchInput}
                    />
                </div>
                <Table
                    className="flex-child"
                    tableHeader={this.getTableHeader()}
                    tableRows={this.getTableRows()}
                    tableColumns={this.getTableColumns()}
                />
            </React.Fragment>,
            "slim-scroll flex-column flex-row-gap-10px"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="flex">
                    {this.getOkButton()}
                    <CancelButton onClick={this.handleCloseModalClick} />
                </div>
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                className="custom-formula"
                modalId={this.props.id}
                header={modelHelper.buildModalSection(<Translate value="customFandecks.customFandecks" />)}
                onClose={this.handleCloseModalClick}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{width: "60%", height: "100%"}}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        customFandeckList: store.global.customFandeckList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchSelectCustomFandeckAction: (tabId, fandeck) => {
            dispatch(customTabActions.selectCustomFandeck(tabId, fandeck));
        },
        dispatchRemoveCustomFandeckAction: (fandeck) => {
            dispatch(
                navigationActions.deleteItemConfirmation(
                    componentTypes.MODAL_NO_TAB,
                    customTabActions.removeCustomFandeck(fandeck),
                    translate("customFandecks.deleteCustomFandeck")
                )
            );
        },
        dispatchCloseCustomFandecksModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.CUSTOM_FANDECKS_MODAL));
        },
        dispatchOpenAddCustomFandeckModalAction: (tabId) => {
            dispatch(
                navigationActions.openModalWithParams(tabId, componentTypes.EDIT_CUSTOM_FANDECK_MODAL, {fandeck: null})
            );
        },
        dispatchOpenEditCustomFandeckModalAction: (tabId, fandeck) => {
            dispatch(
                navigationActions.openModalWithParams(tabId, componentTypes.EDIT_CUSTOM_FANDECK_MODAL, {
                    fandeck: fandeck
                })
            );
        }
    };
};

export default CustomFandecksModal = connect(mapStoreToProps, mapDispatchToProps)(CustomFandecksModal);
